// grey
export const v3ColourGray100 = '#F3F4F6'
export const v3ColourGray200 = '#E5E7EB'
export const v3ColourGray300 = '#D1D5DB'
export const v3ColourGray500 = '#6B7280'
export const v3ColourGray700 = '#374151'

export const brandTrafficGreen = '#75D99D'

export const text_muted = v3ColourGray500
export const text_primary = v3ColourGray700

export const tableBorderColor = v3ColourGray100

export const backgroundBlue = '#DFEFFF'
export const backgroundPink = '#FFE4FF'
